import { Select, SpeedDial, alpha, darken, styled } from '@mui/material';

export const FinancialProductActionSelect = styled(Select)(() => ({
  '& .MuiSelect-select': {
    padding: '0 !important',
    overflow: 'visible'
  }
}));

export const FinancialProductActionDial = styled(SpeedDial)(({ theme }) => ({
  position: 'absolute',
  right: 0,
  '& .MuiSpeedDial-fab': {
    width: '40px',
    height: '40px',
    backgroundColor: 'transparent',
    color: theme.palette.primary.main,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.08)
    }
  },
  '& .MuiSpeedDial-actions': {
    display: 'flex',
    gap: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      marginRight: theme.spacing(-4.5)
    }
  },
  '& .MuiSpeedDialAction-fab': {
    margin: 0,
    '& > svg': {
      fontSize: '1.5rem'
    },
    '&:not(.Mui-disabled)': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.common.white,
      '&:hover': {
        backgroundColor: darken(theme.palette.secondary.main, 0.2)
      }
    }
  }
}));